import React from "react";

export const Privacy = (props) => {
  console.log(props);
  return (
    <div>
      <div id="privacy">
        <div className="container">
          <div className="container">
            <div className="list-style">
              <div className="">
                <ul>
                  {props.data
                    ? props.data.map((item, index) => (
                        <div key={`${item.title}-${index}`} className="">
                          <h3 className="privacy-title">{item.title}</h3>
                          {item.text?.map((text) => (
                            <p>{text}</p>
                          ))}
                        </div>
                      ))
                    : "loading"}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
